if(BSS_B2B) {
  setTimeout(() => {
    if (!window.location.pathname.includes("product")) {
        const quickViews = document.querySelectorAll(".modal");
        quickViews.forEach((quickView) => {
          const mutationObserver = new MutationObserver((recordList, observe) => {
              BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false, true);
          });
             mutationObserver.observe(quickView, { attributes: true });
        })
    }
  }, 5000);
   if (window.location.pathname.includes("/pages/") ||
      window.location.pathname.includes("/account/register")
     ) {
       setTimeout(() =>{
          const formVertical = document.querySelector(".form-vertical");
          if (formVertical) {
            const lstField = document.querySelectorAll(".form-vertical .field");
            lstField.forEach((item) => {
              item.classList.add("form-field");
              const labelItem = item.querySelector("label");
              const inputItem = item.querySelector("input");
              if (labelItem && inputItem) {
                labelItem.classList.add("form-field-title");
                inputItem.classList.add("form-field-input");
                inputItem.classList.add("form-field-text");
                inputItem.insertAdjacentElement("afterend", labelItem);
                inputItem.placeholder = " ";
              }
            });
          }
    
         //field rf
          document.querySelectorAll("form[action='/account'] .form-group:not(.field-country-field, .field-accepts-marketing, .formbuilder-checkbox-group, .formbuilder-radio-group)").forEach((item) => {
          item.classList.add("form-field");
          const input = item.querySelector("input");
          const label = item.querySelector("label");
          const select = item.querySelector("select");
          const textarea = item.querySelector("textarea");
          if ((input || select || textarea) && label) {
              label.classList.add("form-field-title");
              if (input) {
                  input.classList.add("form-field-input");
                  input.classList.add("form-field-text");
                  input.placeholder = " ";
                  input.insertAdjacentElement("afterend", label);
              }
              if (select) {
                  select.insertAdjacentElement("afterend", label);
              }
              if (textarea) {
                  textarea.insertAdjacentElement("afterend", label);
              }
            }
          });
       }, 300)
     
     
     }

  let counter = 0;
  let selector = ".bss-b2b-discount-code-wrapper.bss-config-header"
  const interval = setInterval(() => {
      if ($(selector).length > 0) {
          const dcBox = document.querySelector(".bss-b2b-discount-code-wrapper.bss-config-header")
          document.querySelector(".cart-sidebar").insertAdjacentElement("afterbegin",dcBox);
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100);

  let counter1 = 0;
  let selector1 = ".bss-b2b-tax-ex-wrapper.bss-config-header"
  const interval1 = setInterval(() => {
      if ($(selector1).length > 0) {
          const dcBox = document.querySelector(".bss-b2b-discount-code-wrapper.bss-config-header")
          document.querySelector(".cart-sidebar").insertAdjacentElement("afterbegin",dcBox);
          clearInterval(interval1);
      } else {
          counter1 += 100;
          if (counter1 >= 10000) {
              clearInterval(interval1);
          }
      }
  }, 100);
}